import { IconHistory } from './IconHistory'
import React from 'react'
import { useAtomValue } from 'jotai'
import * as state from '../../../states'

type IHistoryIconBtn = {
	value: Array<any>
	onClick?: (e: React.MouseEvent) => void
}

export const HistoryIconBtn = ({
	value,
	onClick
}: IHistoryIconBtn) => {
	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const isDataNotEmpty = value?.length > 0
	const fillColor = isDataNotEmpty ? 'var(--mainColor)' :
		isThemeDark ? 'var(--darkBodyColor)' : 'black'

	return (
		<i
			className={'icon-history'}
			style={{
				padding: '7px',
				cursor: isDataNotEmpty ? 'pointer' : 'auto'
			}}
			onClick={(e) => isDataNotEmpty && onClick && onClick(e)}
		>
			<IconHistory fill={fillColor}/>
		</i>
	)
}